export const environment = {
  production: false,
  OnetrustCookieConsentKey: '29145a4b-89f5-45ce-ab99-7980e3df4ff5-test',
  helpUrl: 'https://help-preview.mysedgwick.com/mySedgwick5/Help.htm',
};
